import { FormControlLabel, Radio, Tooltip } from '@mui/material';

export const RADIO_DISABLED_TOOLTIP =
  'Selection cannot be changed while one option contains a placeholder';

export type ToolTipRadioWrapperProps = {
  title?: string;
  label?: string;
  disabled?: boolean;
  value?: string;
};

const ToolTipRadioWrapper = (props: ToolTipRadioWrapperProps) => {
  const { title = RADIO_DISABLED_TOOLTIP, disabled, label, value } = props;

  const internalFormControl = (
    <FormControlLabel
      value={value}
      control={<Radio value={value} color="default" disabled={disabled} />}
      label={label}
    />
  );

  if (disabled) {
    return <Tooltip title={title}>{internalFormControl}</Tooltip>;
  } else {
    return <>{internalFormControl}</>;
  }
};

export default ToolTipRadioWrapper;
